module.exports = __webpack_public_path__ + "static/media/movingAverageCrossover.32ea8ce1.png";